export default {
	lineStatus: '状态',
	subtotal: '小计',
	buyNum: '数量',
	foregift: '押金',
	unitPrice: '单价',
	specifications: '规格',
	goodsName: '商品名称',
	order_type: '订单类型',
	Remittance_id: '付款识别码',
	download_btn: '下载租赁清单',
	cancel: '取消订单',
	notes_tishi: '汇款申请单填写示意图：为了您顺利的完成转账汇款，请在汇款用途一栏中正确的填写付款识别码',
	notes_six: '网上预租不会以订单无效、订单异常、系统升级等名义向您发送短信或者链接要求您提供银行卡以及验证码信息，请您加强防范意识，谨防受骗。',
	notes_five: '汇款后5个工作日如果网站订单未更新为"已支付"状态请务必联系， 如"未支付"状态订单没有在规定的时间内付款或者未联系我们将一律视为无效订单，我司将不负任何责任。',
	notes_four: '汇款金额请与应付金额保持一致，请勿多汇款或者少汇款。',
	notes_three: '汇款时请将下面的付款识别码填写到汇款单。',
	notes_two: '汇款后请等待确认收款。到账周期一般为1-3个工作日。',
	notes_one_floot: '前通过银行汇到以上指定账号，请您尽快汇清款项，逾期订单将自动取消。',
	notes_one_header: '请将待支付款项在',
	need_attention_text: '注意事项：',
	bank_account: '银行账号',
	unit_opener: '开户单位',
	bank_deposit: '开户行',
	remittance_title: '转账汇款指定账号',
	unpaid: '未支付',
	pendding: '退款待审核',
  verified: '退款审核通过',
  rejected: '退款已拒绝',
  refunding: '待退款',
  refunded: '已退款',
  cancelled:' 已取消',
	completed: '已完成',
	submitted: '已提交',
	paid: '已支付',
	cancell: '已取消',
	disbaled: '已失效',
	penddingPay: '部分支付',
	finish: '已处理',
	online: '网银支付',
	cash: '现金刷卡',
	balance: '余额支付',
	wire: '转账汇款',
	miniapps: '小程序微信支付',
	wechat: '微信支付',
	alipay: '支付宝支付',
	wechat_scan: '微信扫码支付',
	alipay_scan: '支付宝扫码支付',
	wechat_h5: '微信H5支付',
	info_tip: '信息',
	info_content: '确定取消该订单吗？点击确认将取消订单，订单取消后无法恢复！',
	info_continue_content: '确定继续支付该订单？'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn/order_info.js